/**
 * Vuely Global Components
 */
// section tooltip
import Breadcrumbs from './components/Breadcrumbs/Index.vue'
import AlertBox from './components/Alert/Index.vue'
import ConfirmBox from './components/Confirm/Index.vue'
import UserProfile from './modules/UserProfile/Index.vue'

const GlobalComponents = {
   install(Vue) {
      Vue.component('Breadcrumbs', Breadcrumbs);
      Vue.component('AlertBox', AlertBox)
      Vue.component('ConfirmBox', ConfirmBox)
      Vue.component('UserProfile', UserProfile)
   }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js